import { createHash } from "crypto";
import { Color } from "three";
import { getClassificationColors, classifications } from "../../../classifications";

let classificationColors = [];
getClassificationColors().then(result => classificationColors = result);

const parseHex = (text, min, max) => {
  return parseInt(text.slice(min, max), 16);
};

const hexToRGB = (hex) => {
  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);
  return [r,g,b];
};

export const getClassFromAlias = (alias) => {
  let classNum = -1;
  classifications.forEach(classification => {
    if (classification.alias.includes(alias.toLowerCase())) {
      classNum = classification.id;
    }
  });

  return classNum;
};

const getColorFromClassNum = (classNum) => {
  const rgbColor = hexToRGB(classificationColors[classNum]);
  return rgbColor;
};

export const textToColor = (text, opacity=1.0) => {
  let classNum = getClassFromAlias(text);

  // If alias is similar to any of the defined classes (don't want to use 0,1 since white
  // and black are used for highlights and training areas)
  if (classNum > 1) {
    let rgbColor = getColorFromClassNum(classNum);
    return `rgba(${Math.ceil(rgbColor[0])}, ${Math.ceil(rgbColor[1])}, ${Math.ceil(rgbColor[2])}, ${opacity})`;
  }
  let [r,g,b,a] = textToColorArray(text, opacity);

  return `rgba(${Math.ceil(r)}, ${Math.ceil(g)}, ${Math.ceil(b)}, ${a})`;
};

export const textToColorArray = (text, opacity=1.0) => {
  const colorHash = createHash('md5');
  const hash = colorHash.update(text).digest('hex');
  const h = (parseHex(hash, 0, 8) + parseHex(hash, 8, 16)) % 360;
  const s = 50 + (parseHex(hash, 16, 24) % 50);
  const l = 25 + (parseHex(hash, 24, 32) % 50);

  const color = new Color(`hsl(${h}, ${s}%, ${l}%)`);
  const {r,g,b} = color.multiplyScalar(255);

  return [Math.ceil(r), Math.ceil(g), Math.ceil(b), opacity];
};



